import {
  DropzoneCloseAlert,
  DropzoneInvalidFileTypeAlert,
  DropzoneSubmitAlert,
  DropzoneTooBigFilesAlert,
} from 'pkg/components/FileUploader/DropzoneAlert/Alerts';
import { AlertState } from 'pkg/components/FileUploader/useFileUploaderAlerts';

interface DropzoneAlertProps {
  alert: AlertState;
  disableAlert: () => void;
  closeWithPendingFiles: () => void;
  fileTypes?: string[];
}

export const DropzoneAlert = ({
  alert,
  disableAlert,
  closeWithPendingFiles,
  fileTypes = [],
}: DropzoneAlertProps): JSX.Element | null => {
  switch (alert) {
    case AlertState.SUBMIT:
      return <DropzoneSubmitAlert onAccept={disableAlert} />;
    case AlertState.CLOSE:
      return <DropzoneCloseAlert onAccept={closeWithPendingFiles} onReject={disableAlert} />;
    case AlertState.FILE_TYPE:
      return <DropzoneInvalidFileTypeAlert invalidExtensions={fileTypes} onAccept={disableAlert} />;
    case AlertState.TOO_BIG_FILES:
      return <DropzoneTooBigFilesAlert onAccept={disableAlert} />;
    default:
      return null;
  }
};
